module.exports = __webpack_public_path__ + "static/media/picon1.6ee18209.png";